import React from 'react';
import { PAYMENT_STATUS_OPTIONS } from '../utils/feeFields';
import { formatPaymentStatus } from '../constants/workflowLabels';

/**
 * GOVOPS-1301 — reusable fee / payment / renewal fields for intake and edit forms.
 */
export default function FeeFieldsFormSection({
  values,
  onChange,
  disabled = false,
  idPrefix = 'fee',
  showRenewal = true,
}) {
  const patch = (partial) => onChange({ ...values, ...partial });

  const handleFeeAmount = (e) => {
    const feeAmount = e.target.value;
    const next = { feeAmount };
    if (
      values.paymentStatus === 'unpaid' &&
      (values.balanceDue === '' || values.balanceDue === values.feeAmount)
    ) {
      next.balanceDue = feeAmount;
    }
    patch(next);
  };

  return (
    <fieldset className="rhs-fee-fields" disabled={disabled}>
      <legend className="rhs-card-title">Fees & payment</legend>

      <div className="rhs-form-row">
        <div>
          <label htmlFor={`${idPrefix}-fee-amount`}>Permit fee (USD)</label>
          <input
            id={`${idPrefix}-fee-amount`}
            type="number"
            min="0"
            step="0.01"
            value={values.feeAmount ?? ''}
            onChange={handleFeeAmount}
            placeholder="e.g. 150"
            disabled={disabled}
          />
        </div>
        <div>
          <label htmlFor={`${idPrefix}-balance`}>Balance due</label>
          <input
            id={`${idPrefix}-balance`}
            type="number"
            min="0"
            step="0.01"
            value={values.balanceDue ?? ''}
            onChange={(e) => patch({ balanceDue: e.target.value })}
            disabled={disabled}
          />
        </div>
      </div>

      <label htmlFor={`${idPrefix}-payment-status`}>Payment status</label>
      <select
        id={`${idPrefix}-payment-status`}
        value={values.paymentStatus || 'unpaid'}
        onChange={(e) => patch({ paymentStatus: e.target.value })}
        disabled={disabled}
      >
        {PAYMENT_STATUS_OPTIONS.map((s) => (
          <option key={s} value={s}>
            {formatPaymentStatus(s)}
          </option>
        ))}
      </select>

      <label htmlFor={`${idPrefix}-check`}>Check / reference #</label>
      <input
        id={`${idPrefix}-check`}
        value={values.checkNumber || ''}
        onChange={(e) => patch({ checkNumber: e.target.value })}
        placeholder="Optional payment reference"
        disabled={disabled}
      />

      {showRenewal && (
        <div className="rhs-form-row">
          <div>
            <label htmlFor={`${idPrefix}-renewal`}>Renewal date</label>
            <input
              id={`${idPrefix}-renewal`}
              type="date"
              value={values.renewalDate || ''}
              onChange={(e) => patch({ renewalDate: e.target.value })}
              disabled={disabled}
            />
          </div>
          <div>
            <label htmlFor={`${idPrefix}-expiration`}>Expiration date</label>
            <input
              id={`${idPrefix}-expiration`}
              type="date"
              value={values.expirationDate || ''}
              onChange={(e) => patch({ expirationDate: e.target.value })}
              disabled={disabled}
            />
          </div>
        </div>
      )}
    </fieldset>
  );
}
